import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=f0473250&scoped=true&"
import script from "./CarInfo.vue?vue&type=script&lang=js&"
export * from "./CarInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=f0473250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0473250",
  null
  
)

export default component.exports